// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ================================
   Navbar Container
================================ */
.navbar-glass {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 72px;
  overflow: visible;

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 60px;

  border-radius: 0;
  z-index: 1000;

  transition: transform 0.3s ease;
}

.navbar-actions {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  justify-self: end;
}

.navbar-glass.navbar-hidden {
  transform: translateY(-100%);
  pointer-events: none;
}

/* ================================
   Blur Layer (FIX UTAMA)
================================ */
.navbar-blur {
  position: absolute;
  inset: 0;

  background: rgba(18, 18, 18, 0.8);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);

  border: none;
  border-bottom: 1px solid rgba(67, 67, 67, 0.2);
  border-radius: 0;

  z-index: 0;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.navbar-scrolled .navbar-blur {
  opacity: 1;
}

.navbar-transparent .navbar-blur {
  opacity: 0;
  border-bottom: none;
}

/* ================================
   Header
================================ */
.navbar-header {
  position: relative;
  z-index: 1;

  height: 72px;
  padding: 0;
  width: 100%;
  max-width: 1400px;

  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 24px;

  background: none;
  border: none;
  color: white;
  
  opacity: 1;
  transition: opacity 0.3s ease;
}

.navbar-transparent .navbar-header {
  opacity: 0;
  pointer-events: none;
}

.navbar-left-group {
  display: flex;
  align-items: center;
  gap: 24px;
  grid-column: 1;
}

.navbar-header > a,
.navbar-left-group > a {
  display: flex;
  align-items: center;
  text-decoration: none;
  cursor: pointer;
}

.navbar-logo-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  cursor: pointer;
  width: fit-content;
  max-width: 64px;
}

/* ================================
   Logo
================================ */
.navbar-logo {
  width: 32px;
  height: 32px;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.navbar-header:hover .navbar-logo {
  transform: scale(1.05);
}

/* ================================
   Menu
================================ */
.navbar-menu {
  position: relative;
  z-index: 1;

  opacity: 1;
  transform: translateY(0);

  padding: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 32px;

  pointer-events: auto;
  
  transition: opacity 0.3s ease;
}

.navbar-transparent .navbar-menu {
  opacity: 0;
  pointer-events: none;
}

/* ================================
   Menu Links
================================ */
.navbar-menu a {
  color: #ffffff;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  transition: color 0.25s ease, opacity 0.25s ease;
  text-align: left;
  position: relative;
  padding: 0;
  white-space: nowrap;
}

.navbar-menu a::after {
  display: none;
}

/* Menu colors when scrolled (with background) */
.navbar-scrolled .navbar-menu a {
  color: #ffffff;
}

.navbar-scrolled .navbar-menu a:hover {
  color: #CCFF00;
  opacity: 1;
}

/* Menu colors when transparent (at top) */
.navbar-transparent .navbar-menu a {
  color: #4d4c4c;
}

.navbar-transparent .navbar-menu a:hover {
  color: #121212;
  opacity: 1;
}

/* ================================
   Contact Us Button (Desktop)
================================ */
.navbar-contact-button {
  padding: 12px 20px;
  background: #CCFF00;
  color: #121212 !important;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.4;
  transition: all 0.25s ease;
  border: none;
  cursor: pointer;
  display: inline-block;
  white-space: nowrap;
  width: fit-content;
  grid-column: 3;
  justify-self: end;
}

.navbar-ai-diagnostic-button {
  padding: 12px 20px;
  background: rgba(18, 18, 18, 0.35);
  color: #CCFF00 !important;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.4;
  letter-spacing: 0.08em;
  border: 1px solid rgba(204, 255, 0, 0.5);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  transition: all 0.25s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  text-decoration: none;
}

.navbar-ai-diagnostic-button:hover {
  background: rgba(40, 40, 45, 0.85);
  border-color: rgba(204, 255, 0, 0.7);
  color: #CCFF00 !important;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);
  transform: translateY(-1px);
}

.navbar-lang-toggle {
  width: 40px;
  height: 40px;
  padding: 0;
  border-radius: 8px;
  border: none;
  background: transparent;
  color: #ffffff;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.12em;
  cursor: pointer;
  transition: all 0.25s ease;
  text-align: center;
}

.navbar-lang-toggle:hover {
  border-color: rgba(204, 255, 0, 0.7);
  color: #CCFF00;
  transform: translateY(-1px);
}

.navbar-scrolled .navbar-contact-button {
  background: #CCFF00;
  color: #121212 !important;
}

.navbar-scrolled .navbar-contact-button:hover {
  background: #b8e600;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(204, 255, 0, 0.3);
}

.navbar-transparent .navbar-contact-button {
  background: #121212;
  color: #ffffff !important;
}

.navbar-transparent .navbar-contact-button:hover {
  background: #2a2a2a;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(18, 18, 18, 0.3);
}

/* ================================
   Mobile Hamburger Button
================================ */
.navbar-hamburger {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 1001;

  width: 48px;
  height: 48px;
  padding: 10px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: rgba(32, 32, 32, 0.4);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border: 1px solid rgba(50, 50, 50, 0.3);
  border-radius: 8px;

  cursor: pointer;
  transition: transform 0.3s ease, background 0.3s ease;
}

.navbar-hamburger:hover {
  transform: scale(1.05);
  background: rgba(204, 255, 0, 0.3);
  border-color: rgba(204, 255, 0, 0.5);
}

.navbar-hamburger:active {
  transform: scale(0.95);
}

.navbar-hamburger-logo {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* ================================
   Sidebar Overlay
================================ */
.navbar-sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1002;

  background: rgba(18, 18, 18, 0.7);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

/* ================================
   Sidebar
================================ */
.navbar-sidebar {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1003;

  width: 240px;
  max-width: calc(75 * var(--vw));

  background: rgba(18, 18, 18, 0.98);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-left: 1px solid rgba(49, 49, 49, 0.3);

  display: flex;
  flex-direction: column;
  box-shadow: -4px 0 24px rgba(49, 49, 49, 0.2);
}

/* ================================
   Sidebar Header
================================ */
.navbar-sidebar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  border-bottom: 1px solid rgba(27, 27, 27, 0.2);
}

.navbar-sidebar-logo {
  width: 32px;
  height: 32px;
  object-fit: contain;
}

.navbar-sidebar-close {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;

  background: none;
  border: none;
  color: #ffffff;
  font-size: 32px;
  line-height: 1;
  cursor: pointer;

  border-radius: 8px;
  transition: background 0.2s ease, transform 0.2s ease;
}

.navbar-sidebar-close:hover {
  background: rgba(204, 255, 0, 0.2);
  transform: scale(1.1);
  color: #CCFF00;
}

.navbar-sidebar-close:active {
  transform: scale(0.95);
}

/* ================================
   Sidebar Menu
================================ */
.navbar-sidebar-menu {
  display: flex;
  flex-direction: column;
  padding: 20px 0;
  gap: 8px;
}

.navbar-sidebar-menu a {
  display: block;
  padding: 16px 20px;
  color: #ffffff;
  text-decoration: none;
  font-size: 18px;
  font-weight: 600;
  transition: background 0.2s ease, color 0.2s ease;
  border-left: 3px solid transparent;
}

.navbar-sidebar-menu a:hover {
  background: rgba(204, 255, 0, 0.1);
  border-left-color: #CCFF00;
  color: #CCFF00;
}

.navbar-sidebar-menu a:active {
  background: rgba(18, 18, 18, 0.2);
}

/* ================================
   Contact Us Button (Mobile Sidebar)
================================ */
.navbar-sidebar-contact-button {
  margin: 12px 20px 0 20px;
  padding: 14px 24px !important;
  background: #CCFF00;
  color: #121212 !important;
  border-radius: 8px;
  font-weight: 500 !important;
  text-align: center;
  transition: all 0.2s ease;
  border: none;
  cursor: pointer;
  display: block;
  border-left: 3px solid transparent !important;
}

.navbar-sidebar .navbar-lang-toggle {
  margin: 12px 20px 0 20px;
  padding: 14px 24px;
  width: calc(100% - 40px);
  text-align: center;
  font-size: 14px;
  border-radius: 8px;
}

.navbar-sidebar-contact-button:hover {
  background: #b8e600;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(204, 255, 0, 0.3);
}

.navbar-sidebar-contact-button:active {
  transform: translateY(0);
  background: #a8d600;
}

/* Link component from react-router-dom renders as <a> */
.navbar-menu Link {
  display: inline-block;
}

.navbar-menu a,
.navbar-menu Link {
  transition: color 0.25s ease, opacity 0.25s ease;
}

/* ================================
   Mobile Responsive
================================ */
@media (max-width: 768px) {
  .navbar-glass {
    display: none !important;
  }
}

@media (min-width: 769px) {
  .navbar-hamburger,
  .navbar-sidebar-overlay,
  .navbar-sidebar {
    display: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/component/navbar/navbar.css"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;;EAEjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;;EAEf,gBAAgB;EAChB,aAAa;;EAEb,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;;kCAEkC;AAClC;EACE,kBAAkB;EAClB,QAAQ;;EAER,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;;EAEnC,YAAY;EACZ,8CAA8C;EAC9C,gBAAgB;;EAEhB,UAAU;EACV,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;;kCAEkC;AAClC;EACE,kBAAkB;EAClB,UAAU;;EAEV,YAAY;EACZ,UAAU;EACV,WAAW;EACX,iBAAiB;;EAEjB,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,SAAS;;EAET,gBAAgB;EAChB,YAAY;EACZ,YAAY;;EAEZ,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;kCAEkC;AAClC;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;kCAEkC;AAClC;EACE,kBAAkB;EAClB,UAAU;;EAEV,UAAU;EACV,wBAAwB;;EAExB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;;EAET,oBAAoB;;EAEpB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;;kCAEkC;AAClC;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gDAAgD;EAChD,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA,gDAAgD;AAChD;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA,0CAA0C;AAC1C;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;;kCAEkC;AAClC;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,wCAAwC;EACxC,2CAA2C;EAC3C,2BAA2B;EAC3B,mCAAmC;EACnC,0BAA0B;EAC1B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,yBAAyB;EACzB,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;;kCAEkC;AAClC;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,aAAa;;EAEb,WAAW;EACX,YAAY;EACZ,aAAa;;EAEb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,uCAAuC;EACvC,kBAAkB;;EAElB,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,sBAAsB;EACtB,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;kCAEkC;AAClC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;;EAEb,iCAAiC;EACjC,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;;kCAEkC;AAClC;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,aAAa;;EAEb,YAAY;EACZ,+BAA+B;;EAE/B,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,4CAA4C;;EAE5C,aAAa;EACb,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;;kCAEkC;AAClC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;;EAEf,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;kCAEkC;AAClC;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,iDAAiD;EACjD,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;kCAEkC;AAClC;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,wDAAwD;AACxD;EACE,qBAAqB;AACvB;;AAEA;;EAEE,gDAAgD;AAClD;;AAEA;;kCAEkC;AAClC;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;;;IAGE,wBAAwB;EAC1B;AACF","sourcesContent":["/* ================================\n   Navbar Container\n================================ */\n.navbar-glass {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  width: 100%;\n  height: 72px;\n  overflow: visible;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 60px;\n\n  border-radius: 0;\n  z-index: 1000;\n\n  transition: transform 0.3s ease;\n}\n\n.navbar-actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  justify-self: end;\n}\n\n.navbar-glass.navbar-hidden {\n  transform: translateY(-100%);\n  pointer-events: none;\n}\n\n/* ================================\n   Blur Layer (FIX UTAMA)\n================================ */\n.navbar-blur {\n  position: absolute;\n  inset: 0;\n\n  background: rgba(18, 18, 18, 0.8);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n\n  border: none;\n  border-bottom: 1px solid rgba(67, 67, 67, 0.2);\n  border-radius: 0;\n\n  z-index: 0;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.navbar-scrolled .navbar-blur {\n  opacity: 1;\n}\n\n.navbar-transparent .navbar-blur {\n  opacity: 0;\n  border-bottom: none;\n}\n\n/* ================================\n   Header\n================================ */\n.navbar-header {\n  position: relative;\n  z-index: 1;\n\n  height: 72px;\n  padding: 0;\n  width: 100%;\n  max-width: 1400px;\n\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  align-items: center;\n  gap: 24px;\n\n  background: none;\n  border: none;\n  color: white;\n  \n  opacity: 1;\n  transition: opacity 0.3s ease;\n}\n\n.navbar-transparent .navbar-header {\n  opacity: 0;\n  pointer-events: none;\n}\n\n.navbar-left-group {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  grid-column: 1;\n}\n\n.navbar-header > a,\n.navbar-left-group > a {\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.navbar-logo-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-decoration: none;\n  cursor: pointer;\n  width: fit-content;\n  max-width: 64px;\n}\n\n/* ================================\n   Logo\n================================ */\n.navbar-logo {\n  width: 32px;\n  height: 32px;\n  object-fit: contain;\n  transition: transform 0.3s ease;\n}\n\n.navbar-header:hover .navbar-logo {\n  transform: scale(1.05);\n}\n\n/* ================================\n   Menu\n================================ */\n.navbar-menu {\n  position: relative;\n  z-index: 1;\n\n  opacity: 1;\n  transform: translateY(0);\n\n  padding: 0;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 32px;\n\n  pointer-events: auto;\n  \n  transition: opacity 0.3s ease;\n}\n\n.navbar-transparent .navbar-menu {\n  opacity: 0;\n  pointer-events: none;\n}\n\n/* ================================\n   Menu Links\n================================ */\n.navbar-menu a {\n  color: #ffffff;\n  text-decoration: none;\n  font-size: 16px;\n  font-weight: 500;\n  transition: color 0.25s ease, opacity 0.25s ease;\n  text-align: left;\n  position: relative;\n  padding: 0;\n  white-space: nowrap;\n}\n\n.navbar-menu a::after {\n  display: none;\n}\n\n/* Menu colors when scrolled (with background) */\n.navbar-scrolled .navbar-menu a {\n  color: #ffffff;\n}\n\n.navbar-scrolled .navbar-menu a:hover {\n  color: #CCFF00;\n  opacity: 1;\n}\n\n/* Menu colors when transparent (at top) */\n.navbar-transparent .navbar-menu a {\n  color: #4d4c4c;\n}\n\n.navbar-transparent .navbar-menu a:hover {\n  color: #121212;\n  opacity: 1;\n}\n\n/* ================================\n   Contact Us Button (Desktop)\n================================ */\n.navbar-contact-button {\n  padding: 12px 20px;\n  background: #CCFF00;\n  color: #121212 !important;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 1.4;\n  transition: all 0.25s ease;\n  border: none;\n  cursor: pointer;\n  display: inline-block;\n  white-space: nowrap;\n  width: fit-content;\n  grid-column: 3;\n  justify-self: end;\n}\n\n.navbar-ai-diagnostic-button {\n  padding: 12px 20px;\n  background: rgba(18, 18, 18, 0.35);\n  color: #CCFF00 !important;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 1.4;\n  letter-spacing: 0.08em;\n  border: 1px solid rgba(204, 255, 0, 0.5);\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  transition: all 0.25s ease;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  white-space: nowrap;\n  text-decoration: none;\n}\n\n.navbar-ai-diagnostic-button:hover {\n  background: rgba(40, 40, 45, 0.85);\n  border-color: rgba(204, 255, 0, 0.7);\n  color: #CCFF00 !important;\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);\n  transform: translateY(-1px);\n}\n\n.navbar-lang-toggle {\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  border-radius: 8px;\n  border: none;\n  background: transparent;\n  color: #ffffff;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.12em;\n  cursor: pointer;\n  transition: all 0.25s ease;\n  text-align: center;\n}\n\n.navbar-lang-toggle:hover {\n  border-color: rgba(204, 255, 0, 0.7);\n  color: #CCFF00;\n  transform: translateY(-1px);\n}\n\n.navbar-scrolled .navbar-contact-button {\n  background: #CCFF00;\n  color: #121212 !important;\n}\n\n.navbar-scrolled .navbar-contact-button:hover {\n  background: #b8e600;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(204, 255, 0, 0.3);\n}\n\n.navbar-transparent .navbar-contact-button {\n  background: #121212;\n  color: #ffffff !important;\n}\n\n.navbar-transparent .navbar-contact-button:hover {\n  background: #2a2a2a;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(18, 18, 18, 0.3);\n}\n\n/* ================================\n   Mobile Hamburger Button\n================================ */\n.navbar-hamburger {\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  z-index: 1001;\n\n  width: 48px;\n  height: 48px;\n  padding: 10px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  background: rgba(32, 32, 32, 0.4);\n  backdrop-filter: blur(14px);\n  -webkit-backdrop-filter: blur(14px);\n  border: 1px solid rgba(50, 50, 50, 0.3);\n  border-radius: 8px;\n\n  cursor: pointer;\n  transition: transform 0.3s ease, background 0.3s ease;\n}\n\n.navbar-hamburger:hover {\n  transform: scale(1.05);\n  background: rgba(204, 255, 0, 0.3);\n  border-color: rgba(204, 255, 0, 0.5);\n}\n\n.navbar-hamburger:active {\n  transform: scale(0.95);\n}\n\n.navbar-hamburger-logo {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n/* ================================\n   Sidebar Overlay\n================================ */\n.navbar-sidebar-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1002;\n\n  background: rgba(18, 18, 18, 0.7);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n}\n\n/* ================================\n   Sidebar\n================================ */\n.navbar-sidebar {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1003;\n\n  width: 240px;\n  max-width: calc(75 * var(--vw));\n\n  background: rgba(18, 18, 18, 0.98);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border-left: 1px solid rgba(49, 49, 49, 0.3);\n\n  display: flex;\n  flex-direction: column;\n  box-shadow: -4px 0 24px rgba(49, 49, 49, 0.2);\n}\n\n/* ================================\n   Sidebar Header\n================================ */\n.navbar-sidebar-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px;\n  border-bottom: 1px solid rgba(27, 27, 27, 0.2);\n}\n\n.navbar-sidebar-logo {\n  width: 32px;\n  height: 32px;\n  object-fit: contain;\n}\n\n.navbar-sidebar-close {\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  background: none;\n  border: none;\n  color: #ffffff;\n  font-size: 32px;\n  line-height: 1;\n  cursor: pointer;\n\n  border-radius: 8px;\n  transition: background 0.2s ease, transform 0.2s ease;\n}\n\n.navbar-sidebar-close:hover {\n  background: rgba(204, 255, 0, 0.2);\n  transform: scale(1.1);\n  color: #CCFF00;\n}\n\n.navbar-sidebar-close:active {\n  transform: scale(0.95);\n}\n\n/* ================================\n   Sidebar Menu\n================================ */\n.navbar-sidebar-menu {\n  display: flex;\n  flex-direction: column;\n  padding: 20px 0;\n  gap: 8px;\n}\n\n.navbar-sidebar-menu a {\n  display: block;\n  padding: 16px 20px;\n  color: #ffffff;\n  text-decoration: none;\n  font-size: 18px;\n  font-weight: 600;\n  transition: background 0.2s ease, color 0.2s ease;\n  border-left: 3px solid transparent;\n}\n\n.navbar-sidebar-menu a:hover {\n  background: rgba(204, 255, 0, 0.1);\n  border-left-color: #CCFF00;\n  color: #CCFF00;\n}\n\n.navbar-sidebar-menu a:active {\n  background: rgba(18, 18, 18, 0.2);\n}\n\n/* ================================\n   Contact Us Button (Mobile Sidebar)\n================================ */\n.navbar-sidebar-contact-button {\n  margin: 12px 20px 0 20px;\n  padding: 14px 24px !important;\n  background: #CCFF00;\n  color: #121212 !important;\n  border-radius: 8px;\n  font-weight: 500 !important;\n  text-align: center;\n  transition: all 0.2s ease;\n  border: none;\n  cursor: pointer;\n  display: block;\n  border-left: 3px solid transparent !important;\n}\n\n.navbar-sidebar .navbar-lang-toggle {\n  margin: 12px 20px 0 20px;\n  padding: 14px 24px;\n  width: calc(100% - 40px);\n  text-align: center;\n  font-size: 14px;\n  border-radius: 8px;\n}\n\n.navbar-sidebar-contact-button:hover {\n  background: #b8e600;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(204, 255, 0, 0.3);\n}\n\n.navbar-sidebar-contact-button:active {\n  transform: translateY(0);\n  background: #a8d600;\n}\n\n/* Link component from react-router-dom renders as <a> */\n.navbar-menu Link {\n  display: inline-block;\n}\n\n.navbar-menu a,\n.navbar-menu Link {\n  transition: color 0.25s ease, opacity 0.25s ease;\n}\n\n/* ================================\n   Mobile Responsive\n================================ */\n@media (max-width: 768px) {\n  .navbar-glass {\n    display: none !important;\n  }\n}\n\n@media (min-width: 769px) {\n  .navbar-hamburger,\n  .navbar-sidebar-overlay,\n  .navbar-sidebar {\n    display: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
